import { createStore } from 'vuex'
import featureConfig from './featureConfig'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { featureConfig }
})
